module.exports = __webpack_public_path__ + "img/icon_gray_medal.31417bc5.png";